import { createLucideIcon } from "lucide-react";

export const UserGroup = createLucideIcon(
    "UserGroup",
    [
        [
            "path",
            {
                d: "M15.5 7.5C15.5 9.433 13.933 11 12 11C10.067 11 8.5 9.433 8.5 7.5C8.5 5.567 10.067 4 12 4C13.933 4 15.5 5.567 15.5 7.5Z",
                key: "1a18rp",
            },
        ],
        [
            "path",
            {
                d: "M18 11C19.3807 11 20.5 9.8807 20.5 8.5C20.5 7.1193 19.3807 6 18 6",
                key: "1c4ieu",
            },
        ],
        [
            "path",
            {
                d: "M20.774 18C21.5233 18 22.1193 17.5285 22.6545 16.8691C23.7499 15.5194 21.9513 14.4408 21.2654 13.9126C20.568 13.3756 19.7894 13.0714 19 13",
                key: "1pqzb9",
            },
        ],
        [
            "path",
            {
                d: "M3.226 18C2.4767 18 1.8807 17.5285 1.3456 16.8691C0.2501 15.5194 2.0487 14.4408 2.7346 13.9126C3.432 13.3756 4.2106 13.0714 5 13",
                key: "wslatb",
            },
        ],
        [
            "path",
            {
                d: "M5.5 11C4.1193 11 3 9.8807 3 8.5C3 7.1193 4.1193 6 5.5 6",
                key: "1oifuw",
            },
        ],
        [
            "path",
            {
                d: "M8.0838 15.1112C7.06203 15.743 4.38299 17.0331 6.0147 18.6474C6.81178 19.436 7.69952 20 8.81563 20H15.1844C16.3005 20 17.1882 19.436 17.9853 18.6474C19.617 17.0331 16.938 15.743 15.9162 15.1112C13.5201 13.6296 10.4799 13.6296 8.0838 15.1112Z",
                key: "rvhdbr",
            },
        ],
    ],
);
